/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Home\HomeTitle\HomeTitle.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday September 3rd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 3rd 2024 3:26:46 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import HomeButton from "../HomeButton/HomeButton";
import { useEffect, useState } from "react";
import Styles from "Content/Home/HomeTitle/HomeTitle.module.css";

export default function HomeTitle() {
    const [play, setPlay] = useState(false);

    useEffect(() => {
        setPlay(true);
    }, []);

    const btnData = [
        {
            tabName: "auto-ecole",
            img: "/ecole.png",
            text: "auto-ecole"
        },
        {
            tabName: "courtoisie",
            img: "/courtoi.png",
            text: "courtoisie"
        },
        {
            tabName: "utilitaire",
            img: "/util.png",
            text: "utilitaire"
        }
    ];

    return (
        <div className={`${Styles.holder}`}>
            <div className={`${Styles.homeText}`}>
                <h1 className={`${Styles.homeTitle}`}> {translator.decode("home.title")}</h1>
                <div className={`${Styles.btns}`}>
                    { btnData.map(x => <HomeButton key={Math.random()} img={x.img} tabName={x.tabName} text={x.text} />) }
                </div>
            </div>
            <video className={`${Styles.picture}`} autoPlay={play} loop src="/bg.mp4"></video>
        </div>
    );
};
